import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

const TonList = ({ max = 28, onClick, selectedWeight }) => {
  let tonArray = [];
  for (var i = 1; i <= max; i++) {
    tonArray.push(i);
  }
  const handleClick = (ton) => {
    onClick(ton);
  };

  return tonArray.map((ton) => (
    <List key={ton}>
      <ListItem
        selected={selectedWeight === ton}
        button
        onClick={() => handleClick(ton)}
      >
        <ListItemText>{`${ton} تن`}</ListItemText>
      </ListItem>
    </List>
  ));
};

export default TonList;
